import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Portfolio from '@/components/Portfolio'
import Contacts from '@/components/Contacts'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/about',
			name: 'About',
			component: About
		},
		{
			path: '/portfolio',
			name: 'Portfolio',
			component: Portfolio
		},
		{
			path: '/contacts',
			name: 'Contacts',
			component: Contacts
		}
	],
	mode: 'history',

	scrollBehavior () {
		return { x: 0, y: 0 }
    }
})
